import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.5rem"} }, "Вернуться к редактированию", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.688rem"} }, "Выйти", -1)

import { ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-no-save-data-modal',
  props: {
  /**Заголовок */
  title: {
    type: String,
    default: "Отменить создание?",
  },
},
  emits: ["exit", "cancelExit"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





/**Видимость модального окна */
const isVisible = ref(false);
/**Открыть модальное окно */
const open = () => (isVisible.value = true);
/**Закрыть модальное окно */
const close = () => (isVisible.value = false);

/**При выходе */
const onExit = () => {
  close();
  emit("exit");
};

/**При отмене выхода */
const onCancelExit = () => {
  close();
  emit("cancelExit");
};

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    "is-visible": isVisible.value,
    title: __props.title,
    "is-with-back": false,
    onClose: onCancelExit
  }, {
    content: _withCtx(() => [
      _createTextVNode(" Если выйти сейчас, введенные данные не сохранятся ")
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: onCancelExit
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: onExit
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _: 1
  }, 8, ["is-visible", "title"]))
}
}

})